import * as types from "./types";

function saveData(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function quitarColegioSeleccionado() {
  return { type: types.QUITAR_COLEGIO_SELECCIONADO };
}

function addedPersonasContacto(payload) {
  return { type: types.ADDED_PERSONAS_CONTACTO, payload };
}

function removedPersonasContacto(payload) {
  return { type: types.REMOVED_PERSONAS_CONTACTO, payload };
}

function changedPersonasContacto(payload) {
  return { type: types.CHANGED_PERSONAS_CONTACTO, payload };
}

function limpiarPersonasContacto() {
  return { type: types.LIMPIAR_PERSONAS_CONTACTO };
}

/*---*/
export {
  saveData,
  resetDataSaved,
  quitarColegioSeleccionado,
  addedPersonasContacto,
  removedPersonasContacto,
  changedPersonasContacto,
  limpiarPersonasContacto
};



// WEBPACK FOOTER //
// ./src/ducks/ventasContactos/actions.js